// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1BhuB","left":"StickyBox_left__2OeBp","right":"StickyBox_right__L0PDI"};